export const EMAIL = 0;
export const SMS = 1;